import ForkIcon from 'components/icons/ForkIcon'
import Link from 'next/link'
import TruckNameSection from 'components/HeroSection/TruckNameSection'
import TruckActions, { ActionType } from 'components/HeroSection/TruckActions'
import LinksSection, {
  HeroLinksType
} from 'components/HeroSection/LinksSection'
import Rating from 'components/HeroSection/Rating'
import { MapPinIcon } from '@heroicons/react/24/outline'
import take from 'lodash/take'
import ButtonLink from 'components/ui/ButtonLink'

import PreviousPageLink from 'components/PreviousPageLink'

import { TruckInformationFragment } from './types/TruckInformationFragment'

type Props = {
  heroLinks: HeroLinksType | null
  truck: Omit<TruckInformationFragment, 'market' | 'showAsArchived'> &
    Partial<Pick<TruckInformationFragment, 'market' | 'showAsArchived'>>
  actions: ActionType[]
  goBackText?: string
  goBackPath?: string
  profileApproved?: boolean
}

const TruckInformationSectionContent = ({
  truck,
  actions,
  heroLinks,
  goBackText,
  goBackPath,
  profileApproved
}: Props) => {
  return (
    <div>
      {actions.includes('goBack') && (
        <PreviousPageLink path={goBackPath} text={goBackText} />
      )}
      <TruckNameSection
        instantBook={truck.instantBookEnabled}
        name={truck.name}
        preferredVendor={truck.preferredVendor}
        preferredVendorBadge={truck.preferredVendorBadge}
        profileApproved={profileApproved}
      />
      <Rating ratingInfo={truck.ratingInfo} />

      {truck.market && (
        <div className="mt-2 mb-2 italic text-white flex items-center">
          <div className="inline mr-2">
            <MapPinIcon className="w-6" />
          </div>
          {actions.includes('market') ? (
            <Link
              className="underline"
              href={truck.market.customerPath}
              prefetch={false}
            >
              {truck.market.name}
            </Link>
          ) : (
            <span>{truck.market.name}</span>
          )}
        </div>
      )}
      <div className="mt-2 mb-5 italic text-white flex items-center">
        {truck.foodTypes.length > 0 && (
          <>
            <div className="inline mr-2">
              <ForkIcon />
            </div>
            {take(truck.foodTypes, 5)
              .map((t) => t.name)
              .join(', ')}
          </>
        )}
      </div>

      {!truck.showAsArchived && (
        <TruckActions
          actions={actions}
          menuUrl={truck.menuUrl}
          scheduleUrl={truck.scheduleUrl}
          truckId={truck.id}
        />
      )}
      {truck.showAsArchived && truck.market && (
        <div className="mt-6">
          <ButtonLink
            className="mt-2"
            color="primary"
            href={truck.market.customerTrucksListPath}
            variant="contained"
          >
            <>Food trucks in {truck.market.name}</>
          </ButtonLink>
        </div>
      )}
      {actions.includes('socialMedia') &&
        heroLinks &&
        !truck.showAsArchived && (
          <div className="sm:mt-6 hidden sm:block">
            <LinksSection socialLinks={heroLinks} />
          </div>
        )}
    </div>
  )
}
export default TruckInformationSectionContent
